import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageXrayExperiments_runtime_v4Component } from './page.xray.experiments_runtime_v4/page.xray.experiments_runtime_v4.component';
import { PageXrayExperimentsComponent } from './page.xray.experiments/page.xray.experiments.component';
import { PageXrayDataset_viewer_runtime_v2Component } from './page.xray.dataset_viewer_runtime_v2/page.xray.dataset_viewer_runtime_v2.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageXrayNormality_review_runtime_v4Component } from './page.xray.normality_review_runtime_v4/page.xray.normality_review_runtime_v4.component';
import { PageXrayExperiment_guideComponent } from './page.xray.experiment_guide/page.xray.experiment_guide.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageXrayExperiments_runtime_v7Component } from './page.xray.experiments_runtime_v7/page.xray.experiments_runtime_v7.component';
import { PageXrayData_manager_entry_v1Component } from './page.xray.data_manager_entry_v1/page.xray.data_manager_entry_v1.component';
import { PageXrayNormality_review_runtime_v13Component } from './page.xray.normality_review_runtime_v13/page.xray.normality_review_runtime_v13.component';
import { PageXrayModels_runtime_v1Component } from './page.xray.models_runtime_v1/page.xray.models_runtime_v1.component';
import { PageXrayComponent } from './page.xray/page.xray.component';
import { PageXrayLabel_review_runtime_v7Component } from './page.xray.label_review_runtime_v7/page.xray.label_review_runtime_v7.component';
import { PageXrayExperiments_runtime_v10Component } from './page.xray.experiments_runtime_v10/page.xray.experiments_runtime_v10.component';
import { PageXrayDatasetComponent } from './page.xray.dataset/page.xray.dataset.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageXrayExperiments_runtime_v6Component } from './page.xray.experiments_runtime_v6/page.xray.experiments_runtime_v6.component';
import { PageXrayNormality_review_runtime_v6Component } from './page.xray.normality_review_runtime_v6/page.xray.normality_review_runtime_v6.component';
import { PageXrayExperiments_runtime_v9Component } from './page.xray.experiments_runtime_v9/page.xray.experiments_runtime_v9.component';
import { PageXrayLabel_review_runtime_v3Component } from './page.xray.label_review_runtime_v3/page.xray.label_review_runtime_v3.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageXrayLabel_reviewComponent } from './page.xray.label_review/page.xray.label_review.component';
import { PageXrayDataset_upload_runtime_v1Component } from './page.xray.dataset_upload_runtime_v1/page.xray.dataset_upload_runtime_v1.component';
import { PageXrayLabel_review_runtime_v6Component } from './page.xray.label_review_runtime_v6/page.xray.label_review_runtime_v6.component';
import { PageXrayLabel_review_runtime_v4Component } from './page.xray.label_review_runtime_v4/page.xray.label_review_runtime_v4.component';
import { PageXrayNormality_review_runtime_v5Component } from './page.xray.normality_review_runtime_v5/page.xray.normality_review_runtime_v5.component';
import { PageXrayDataset_viewer_runtime_v1Component } from './page.xray.dataset_viewer_runtime_v1/page.xray.dataset_viewer_runtime_v1.component';
import { PageXrayExperiments_runtime_v3Component } from './page.xray.experiments_runtime_v3/page.xray.experiments_runtime_v3.component';
import { PageXrayExperiments_runtime_v5Component } from './page.xray.experiments_runtime_v5/page.xray.experiments_runtime_v5.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageXrayNormality_review_runtime_v12Component } from './page.xray.normality_review_runtime_v12/page.xray.normality_review_runtime_v12.component';
import { PageXrayNormality_review_runtime_v7Component } from './page.xray.normality_review_runtime_v7/page.xray.normality_review_runtime_v7.component';
import { PageXrayExperiments_runtime_v8Component } from './page.xray.experiments_runtime_v8/page.xray.experiments_runtime_v8.component';
import { PageXrayNormality_review_runtime_v3Component } from './page.xray.normality_review_runtime_v3/page.xray.normality_review_runtime_v3.component';
import { PageXrayLabel_review_runtime_v5Component } from './page.xray.label_review_runtime_v5/page.xray.label_review_runtime_v5.component';
import { PageXrayModelsComponent } from './page.xray.models/page.xray.models.component';
import { PageXrayLabel_review_runtime_v2Component } from './page.xray.label_review_runtime_v2/page.xray.label_review_runtime_v2.component';
import { PageXrayNormality_review_runtime_v14Component } from './page.xray.normality_review_runtime_v14/page.xray.normality_review_runtime_v14.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageXrayLabel_review_runtime_v1Component } from './page.xray.label_review_runtime_v1/page.xray.label_review_runtime_v1.component';
import { PageXrayNormality_reviewComponent } from './page.xray.normality_review/page.xray.normality_review.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ standalone: false, name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageXrayExperiments_runtime_v4Component,
        PageXrayExperimentsComponent,
        PageXrayDataset_viewer_runtime_v2Component,
        PortalSeasonFormDropdownComponent,
        PortalPostListComponent,
        PortalSeasonTreeComponent,
        PortalPostDetailComponent,
        LayoutEmptyComponent,
        PageXrayNormality_review_runtime_v4Component,
        PageXrayExperiment_guideComponent,
        PortalSeasonModalComponent,
        LayoutSidebarComponent,
        PageXrayExperiments_runtime_v7Component,
        PageXrayData_manager_entry_v1Component,
        PageXrayNormality_review_runtime_v13Component,
        PageXrayModels_runtime_v1Component,
        PageXrayComponent,
        PageXrayLabel_review_runtime_v7Component,
        PageXrayExperiments_runtime_v10Component,
        PageXrayDatasetComponent,
        PortalSeasonLoadingSeasonComponent,
        PageXrayExperiments_runtime_v6Component,
        PageXrayNormality_review_runtime_v6Component,
        PageXrayExperiments_runtime_v9Component,
        PageXrayLabel_review_runtime_v3Component,
        ComponentNavSidebarComponent,
        PageXrayLabel_reviewComponent,
        PageXrayDataset_upload_runtime_v1Component,
        PageXrayLabel_review_runtime_v6Component,
        PageXrayLabel_review_runtime_v4Component,
        PageXrayNormality_review_runtime_v5Component,
        PageXrayDataset_viewer_runtime_v1Component,
        PageXrayExperiments_runtime_v3Component,
        PageXrayExperiments_runtime_v5Component,
        PortalSeasonPaginationComponent,
        PageXrayNormality_review_runtime_v12Component,
        PageXrayNormality_review_runtime_v7Component,
        PageXrayExperiments_runtime_v8Component,
        PageXrayNormality_review_runtime_v3Component,
        PageXrayLabel_review_runtime_v5Component,
        PageXrayModelsComponent,
        PageXrayLabel_review_runtime_v2Component,
        PageXrayNormality_review_runtime_v14Component,
        PortalSeasonLoadingDefaultComponent,
        PageXrayLabel_review_runtime_v1Component,
        PageXrayNormality_reviewComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
